// Separate full-page OAuth navigation from the router and account-link request.
export function redirectToDiscordLogin(returnPath: string) {
  window.location.replace(`/api/v1/auth/login?returnPath=${encodeURIComponent(returnPath)}`);
}
